<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-26 15:17:40
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="block">
      <p>温馨提示：</p>
      <p>1、通用商品可以针对所有直属经销商/门店批量上架，上架商品对所有直属经销商/门店生效；注：直属的意思是直接归总部管理的，且在系统内上级是总部的；</p>
      <p>2、若需对单个经销商/门店进行设置，可在【客户指定商品】中单独上架；</p>
      <p>3、若同一个商品、同一个经销商/门店出现同时满足两个设置的情况，则按指定商品的价格计算，指定商品优先级高于通用商品</p>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="通用商品" name="first">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="generalOnput()">商品上架</el-button>
          <el-button @click="importdata(1)">批量导入</el-button>
          <el-button type="text" @click="is_Obtained=!is_Obtained">{{is_Obtained?'上架':'下架'}}商品管理</el-button>
        </div>
        <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <el-form-item label="商品编号:">
            <el-input v-model="form1.product_sn" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input v-model="form1.product_name" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品属性:" v-if="is_show_attribute==1">
            <el-select v-model="form1.attribute_id">
              <el-option label="全部" value></el-option>
              <el-option
                :label="v.attribute_name"
                :value="v.attribute_id"
                v-for="(v,k) in attributesList"
                :key="k"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否赠品:">
            <el-select v-model="form1.isgift">
              <el-option label="全部" value></el-option>
              <el-option label="赠品" value="1"></el-option>
              <el-option label="非赠品" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getgeneralList()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          border
          class="form1"
          fit
          style="width: 100%"
        >
          <el-table-column prop="product_sn" label="商品编号" fixed></el-table-column>
          <el-table-column prop label="商品信息" cell-class-name="info">
            <template slot-scope="scope">
              <div class="info">
                <div>{{scope.row.product_name}}</div>

                <img :src="scope.row.product_img" alt v-if="scope.row.product_img" />
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="isgift" label="是否赠品">
            <template slot-scope="scope">{{scope.row.isgift==1?"赠品":"非赠品"}}</template>
          </el-table-column>
          <el-table-column prop="product_category_name" label="商品分类"></el-table-column>
          <el-table-column prop="directly_dealer_price" label="商品价格">
            <template slot-scope="scope">
              <!-- {{scope.row}} -->
              <div
                v-for="(v,k) in scope.row.directly_dealer_price"
                :key="k"
                class="price"
                v-if="v.price!=0&&v.level_name"
              >
                <div>{{v.level_name}}:{{v.price}}</div>
              </div>
              <div class="price" v-if="scope.row.directly_shop_directly_price!=0">
                <div>直营门店{{scope.row.directly_shop_directly_price}}</div>
              </div>
              <div class="price" v-if="scope.row.directly_shop_not_directly_price!=0">
                <div>非直营门店{{scope.row.directly_shop_not_directly_price}}</div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
                            prop=""
                            label="返利金额"
                            show-overflow-tooltip>
          </el-table-column>-->
          <el-table-column prop="onshelf_time" label="上架时间" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="attribute_name"
            v-if="is_show_attribute==1"
            label="商品属性"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column prop label="操作" show-overflow-tooltip fixed="right" width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.push_status==2">
                <el-button type="text" size="small" @click="sexclude(scope.row)">排除客户</el-button>
                <el-button type="text" size="small" @click="generalOnput(scope.row.putaway_id)">修改</el-button>
                <el-button
                  type="text"
                  size="small"
                  v-if="is_Obtained"
                  @click="del(scope.row.putaway_id,'up')"
                >上架</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="del(scope.row.putaway_id,'down')"
                  v-if="!is_Obtained"
                >下架</el-button>
              </div>
              
              <div v-if="scope.row.push_status==1">正在发布中，请稍后刷新页面查看~</div>
              <div v-if="scope.row.push_status==3">
                发布失败，
                <a href="javascript:;" @click="again(scope.row,"nomal")">点击重新发布</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-size="pageSize1"
          :total="totalSize1"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="客户指定商品" name="second">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="specifyOnput()">商品上架</el-button>
          <el-button @click="Imports1 =! Imports1">批量导入</el-button>
        </div>
        <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
          <el-form-item label="客户类型:">
            <el-select v-model="form2.type">
              <el-option label="全部" value="0"></el-option>
              <el-option label="经销商" value="2"></el-option>
              <el-option label="门店" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商/门店:">
            <el-col :span="19">
              <el-input v-model="form2.sn" clearable></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 10px;">
              <el-button type="primary" @click="selectRole=!selectRole">选择</el-button>
            </el-col>
          </el-form-item>
          <el-form-item style="margin-left:30px">
            <el-button type="primary" @click="getSpecify()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          :data="tableData2"
          v-loading="loading"
          height="400px"
          border
          stripe
          style="width: 100%;margin: 20px"
        >
          <el-table-column prop="name" label="经销商/门店信息" fixed>
            <template slot-scope="scope">{{scope.row.name}}({{scope.row.sn}})</template>
          </el-table-column>
          <el-table-column prop label="商品信息" show-overflow-tooltip>
            <template slot-scope="scope">
              <!-- scope.row.putaway_id -->
              <el-button type="text" size="small" @click="specify(scope.row)">查看商品信息</el-button>
            </template>
          </el-table-column>
          <el-table-column prop label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.push_status==2">
                <el-button type="text" size="small" @click="specifyOnput(scope.row.putaway_id)">修改</el-button>
                <el-button type="text" size="small" @click="delSpecify(scope.row.putaway_id)">删除</el-button>
              </div>
              <div v-if="scope.row.push_status==1">正在发布中，请稍后刷新页面查看~</div>
              <div v-if="scope.row.push_status==3">
                发布失败，
                <a href="javascript:;" @click="again(scope.row,"specify")">点击重新发布</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNo2"
          :page-size="pageSize2"
          layout="total, prev, pager, next, jumper"
          :total="totalSize2"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
    <customerExclude
      v-if="selectRoleDialog"
      v-on:handleClose="Close"
      @pushData="getSelectinfo"
      :selects="true"
      :putaway="putaway"
    />
    <selectRole
      v-if="selectRole"
      v-on:handleClose="selectRole = false"
      @pushData="getRole"
      :putaway="putaway"
    />
    <specifyDetail
      v-if="specifyDialog"
      v-on:handleClose="specifyDialog = false"
      :putaway="specifyData"
    />
    <Import
      v-if="importDataDialog"
      v-on:handleClose="importDataDialog = false"
      @refresh="getgeneralList"
    />
    <Import1 v-if="Imports1" v-on:handleClose="Imports1 = false" @refresh="getSpecify" />
  </div>
</template>

<script>
import customerExclude from "./customerExclude";
import specifyDetail from "./specifyDetail";
import selectRole from "./selectRole";
import Import from "./Import";
import Import1 from "./Import1";
export default {
  name: "goods-onput",
  data() {
    return {
      importDataDialog: false,
      specifyData: {}, //指定商品 信息 参数弹窗
      specifyDialog: false,
      selectRole: false,
      selectRoleDialog: false,
      is_Obtained: false, //上下架切换
      loading: true,
      activeName: "first",
      attributesList: [], //商品属性列表
      putaway: {}, //通用商品上架ID
      form1: {
        product_sn: "",
        product_name: "",
        role: "",
        isgift: ""
      },
      form2: {
        sn: "",
        type: ""
      },
      tableData1: [],
      tableData2: [],

      //分页
      pageNo1: 1, //页码
      pageSize1: 10, //每页现实的条数
      totalSize1: 0, //总条数
      //分页
      pageNo2: 1, //页码
      pageSize2: 10, //每页现实的条数
      totalSize2: 0, //总条数
      onshelf_status: 1, //上下架状态 通用商品
      generalList: [], //通用商品上下架列表
      importType: 1,
      Imports1: false,
      is_show_attribute: 1
    };
  },

  methods: {
    // 获取一些配置
    getConfig() {
      this.$get("logistics", "/configs.order").then(res => {
        this.is_show_attribute = res.data.product_attribute_on_off;
      });
    },
    // 通用商品上下架列表
    getgeneralList() {
      this.$get("logistics", "/product.putaways", {
        onshelf_status: this.onshelf_status,
        page: this.pageNo1,
        per_page: this.pageSize1,
        ...this.form1
      })
        .then(res => {
          // 获取经销商等级
          this.$get("logistics", "/dealers.level", {}).then(result => {
            this.tableData1 = res.data;
            res.data.forEach((element, key) => {
              element.directly_dealer_price.forEach((v, k) => {
                result.data.forEach(value => {
                  if (v.level_id == value.id) {
                    this.tableData1[key].directly_dealer_price[k].level_name =
                      value.level_name;
                  }
                });
              });
            });
            // this.tableData1.directly_dealer_price[key]

            this.totalSize1 = res.meta.total;
            this.pageNo1 = res.meta.current_page;
            this.loading = false;
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    //通用商品上架
    generalOnput(id) {
      this.$router.push({
        name: "generalOnput",
        query: {
          edit: id
        }
      });
    },
    // 指定商品上架
    specifyOnput(id) {
      this.$router.push({
        name: "specifyOnput",
        query: {
          edit: id
        }
      });
    },
    // 商品属性
    getProductsAttributes() {
      this.$get("logistics", "/product.attributes").then(res => {
        this.attributesList = res.data;
      });
    },
    // 通用商品重新发布
    again(data, temp) {
      if (temp == "specify") {
        var url = "/specify.putaways.repush/" + data.putaway_id;
        this.$post("logistics", url).then(res => {
          this.getSpecify();
        });
      } else {
        var url = "/product.putaways.repush/" + data.putaway_id;
        this.$post("logistics", url).then(res => {
          this.getgeneralList();
        });
      }
    },
    //下架
    del(data, flag) {
      if (flag == "down") {
        this.$confirm(
          "下架后此商品会放入下架商品库，且客户无法看到此商品，确定要下架吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            var url = "/product.putaways/" + data;
            this.$patch("logistics", url, {
              onshelf_status: 2,
              _method: "PATCH"
            }).then(res => {
              this.getgeneralList();
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消下架"
            });
          });
      } else {
        var url = "/product.putaways/" + data;
        this.$patch("logistics", url, {
          onshelf_status: 1,
          _method: "PATCH"
        }).then(res => {
          this.getgeneralList();
          this.$message({
            type: "info",
            message: "上架成功"
          });
        });
      }
    },
    // 通用商品  排除客户
    sexclude(data) {
      this.selectRoleDialog = !this.selectRoleDialog;
      this.putaway = data;
    },
    //获取选择经销商门店
    getSelectinfo(val) {
      var to_sn = "",
        to_type = "",
        exclude_sns = [];
      if (val.data) {
        //多选
        if (val.type === "dealer") {
          val.data.forEach(value => {
            exclude_sns.push(value.dealer_sn);
          });
          var exclude_type = 2;
        } else {
          val.data.forEach(value => {
            exclude_sns.push(value.shop_sn);
          });
          var exclude_type = 3;
        }
        if (this.activeName == "first") {
          var url = "/product.putaways/" + this.putawayId + "/sexclude";
          this.$post("logistics", url, {
            exclude_sns: exclude_sns,
            exclude_type: exclude_type
          }).then(res => {
            this.$message({
              message: "排除成功",
              type: "success"
            });
          });
        }
      } else {
        if (this.activeName == "first") {
          if (val.dealer_sn) {
            to_sn = val.dealer_sn;
            to_type = 2;
          } else {
            to_sn = val.shop_sn;
            to_type = 3;
          }
        }
      }
    },
    handleClick(tab) {},
    handleSizeChange1(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getgeneralList();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;

      this.getgeneralList();
    },
    handleSizeChange2(val) {
      this.pageSize = val;
      this.pageNo = 1;
      //this.getGoodsList();
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.getSpecify();
    },
    Close() {
      this.selectRoleDialog = false;
      this.getgeneralList();
    },
    // 获取指定商品列表
    getSpecify() {
      this.loading = true;
      this.$get("logistics", "/specify.putaways", {
        page: this.pageNo2,
        per_page: this.pageSize2,
        ...this.form2
      }).then(res => {
        this.tableData2 = res.data;
        this.totalSize2 = res.meta.total;
        this.pageNo2 = res.meta.current_page;
        this.loading = false;
      });
    },
    // 删除指定商品
    delSpecify(id) {
      var url = "/specify.putaways/" + id;
      this.$delete("logistics", url).then(res => {
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.getSpecify();
      });
    },
    // 指定商品重新发布

    // 指定商品 选择经销商 和门店
    getRole(value) {
      this.form2.sn = value.shop_sn ? value.shop_sn : value.dealer_sn;
    },
    // 指定商品查看信息
    specify(value) {
      this.specifyData = value;
      this.specifyDialog = !this.specifyDialog;
    },
    importdata(type) {
      this.importType = type;
      this.importDataDialog = !this.importDataDialog;
    }
  },
  created() {
    this.getConfig();
    this.getgeneralList();
    this.getProductsAttributes();
  },
  watch: {
    activeName(value) {
      if (value != "first") {
        this.getSpecify();
      }
    },
    is_Obtained(value) {
      if (value) {
        this.onshelf_status = 2;
      } else {
        this.onshelf_status = 1;
      }
      this.getgeneralList();
    }
  },
  components: {
    customerExclude,
    selectRole,
    specifyDetail,
    Import,
    Import1
  }
};
</script>

<style lang="scss" scoped>
.block {
  height: 125px;
  line-height: 25px;
  background-color: #eee;
  padding-left: 20px;
  margin-bottom: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
}
/deep/.cell {
  height: auto;
  overflow: visible;

  img {
    // height:100px;
    width: 50%;
  }
}
 
/deep/ .price > div {
  text-align: left;
}
/deep/.el-form--inline .el-form-item {
  margin-right: 15px;
}
/deep/.form1 {
  // overflow-y: scroll;
  
  tbody tr {
    // height: 200px;
  }
}
//   .el-table__body{

//     height: 100%;
//     .tbody{
//     height: 100%;

//     }
// }
.el-table td div {
  height: auto !important;
}
td {
  padding: 0 !important;
}
</style>